// import "./Services.css";

// const services = [
//   {
//     title: "ايبوكسي أرضيات بالرياض",
//     image: "/images/epoxy.jpg",
//     description:
//       "تنفيذ احترافي لأعمال ايبوكسي الأرضيات في الرياض للمنازل، المستودعات، المصانع والجراجات بأعلى معايير الجودة والمتانة.",
//     whatsapp: "أرغب في تنفيذ ايبوكسي أرضيات بالرياض",
//   },
//   {
//     title: "دهانات داخلية في الرياض",
//     image: "images/interior.jpg",
//     description:
//       "دهانات داخلية عصرية مع ديكورات فوم وجبس بورد، تشطيبات فاخرة تعكس الذوق الحديث للمنازل والفلل.",
//     whatsapp: "أحتاج دهانات داخلية حديثة في الرياض",
//   },
//   {
//     title: "دهانات خارجية بالرياض",
//     image: "images/exterior.jpg",
//     description:
//       "دهانات خارجية مقاومة للحرارة والعوامل الجوية، ألوان ثابتة وتشطيب يدوم لسنوات في أجواء الرياض.",
//     whatsapp: "أرغب في دهانات خارجية بالرياض",
//   },
//   {
//     title: "ديكورات فوم وجبس بالرياض",
//     image: "/images/decor.jpg",
//     description:
//       "تنفيذ ديكورات فوم وجبس بورد احترافية تضيف لمسة جمالية راقية للمساحات الداخلية.",
//     whatsapp: "أحتاج ديكورات فوم وجبس في الرياض",
//   },
//   {
//     title: "أسقف ألياف ضوئية بالرياض",
//     image: "/images/ceilings.jpg",
//     description:
//       "تصميم وتنفيذ أسقف ألياف ضوئية تمنح المكان فخامة وإضاءة هادئة بتقنيات حديثة.",
//     whatsapp: "أرغب في تنفيذ أسقف ألياف ضوئية بالرياض",
//   },



//   {
//     title: "تركيب ورق جدران بالرياض",
//     image: "/images/wallpaper.jpg",
//     description:
//       "يوفر لكم خدمات وأعمال الديكور العصري مع أحدث موديلات ورق الحائط للجدران 2024. أفضل فني متخصص لتنفيذ ديكورات الجدران العصرية في الرياض، بخبرة تفوق 15 سنة.",
//     whatsapp: "أرغب في تركيب ورق جدران بالرياض",
//   },
//   {
//     title: "دهانات خارجية الرياض – عسيب",
//     image: "/images/exterior-aseeb.jpg",
//     description:
//       "معلم دهانات وديكورات الرياض يقدم دهانات خارجية عالية الجودة، عسيب مقاوم للعوامل الجوية، بألوان جذابة ومتميزة.",
//     whatsapp: "أرغب في دهانات خارجية عسيب بالرياض",
//   },
//   {
//     title: "اسقف الياف ضوئية الرياض – نجوم روز",
//     image: "/images/fiber-optic-stars.jpg",
//     description:
//       "أسقف ألياف ضوئية على شكل نجوم، ديكورات فاخرة، تضيف منظر جميل ورونق خاص لمكانك في الرياض.",
//     whatsapp: "أرغب في تركيب أسقف ألياف ضوئية على شكل نجوم بالرياض",
//   },
//   {
//     title: "اسقف الياف ضوئية الرياض – غيوام",
//     image: "/images/fiber-optic-guwam.jpg",
//     description:
//       "معلم دهانات وديكورات الرياض يقدم تنفيذ أسقف ألياف ضوئية من نوع غيوام لتجربة فخمة وعصرية.",
//     whatsapp: "أرغب في تركيب أسقف ألياف ضوئية غيوام بالرياض",
//   },
//   {
//     title: "دهانات داخلية وفوم الرياض",
//     image: "/images/interior-foam.jpg",
//     description:
//       "دهانات داخلية مع ديكورات فوم، تنفيذ تشطيبات عالية الجودة، تضيف لمسة جمالية للمنازل والفلل.",
//     whatsapp: "أرغب في خدمات دهانات داخلية وفوم بالرياض",
//   },
//   {
//     title: "عوازل سطوح ودهانات داخلية ترميم",
//     image: "/images/roof-insulation-repair.jpg",
//     description:
//       "دهانات وديكورات داخلية، ترميم وتشطيب الأسطح، تطبيق العزل المائي لحماية المنزل.",
//     whatsapp: "أرغب في خدمات عوازل سطوح وترميم دهانات داخلية بالرياض",
//   },
//   {
//     title: "عوازل صوت في الرياض",
//     image: "/images/sound-insulation.jpg",
//     description:
//       "معلم دهانات وديكورات الرياض يقدم حلول عوازل صوتية عالية الجودة، ترميم وإزالة دهانات قديمة، إضافة لمسة احترافية.",
//     whatsapp: "أرغب في تركيب عوازل صوت في الرياض",
//   },


// ];

// const NUMBER = "966582114639";

// export default function Services() {
//   return (
//     <section className="services-section1">
//       <h1 className="main-title1">
//         معلم دهانات وديكورات في الرياض – تشطيب باحتراف
//       </h1>

//       <div className="services-grid1">
//         {services.map((item, i) => (
//           <div className="service-card1" key={i}>
//             <div className="image-box1">
//               <img src={item.image} alt={item.title} />
//             </div>

//             <div className="content1">
//               <h2>{item.title}</h2>
//               <p>{item.description}</p>

//               <a
//                 href={`https://wa.me/${NUMBER}?text=${encodeURIComponent(
//                   item.whatsapp
//                 )}`}
//                 target="_blank"
//                 rel="noreferrer"
//                 className="whatsapp-btn1"
//               >
//                 تواصل عبر واتساب
//               </a>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }







import React from "react";
import "./Services.css";

// Import images
import epoxyImage from "./images/epoxy.jpg";
import interiorImage from "./images/interior.jpg";
import exteriorImage from "./images/exterior.jpg";
// import woodImage from "./images/wood.jpg";
import decorImage from "./images/decor.jpg";
import ceilingsImage from "./images/ceilings.jpg";
// import wallpaperImage from "./images/wallpaper.jpg";
// import exteriorAseebImage from "./images/exterior-aseeb.jpg";
// import fiberOpticStarsImage from "./images/fiber-optic-stars.jpg";
// import fiberOpticGuwamImage from "./images/fiber-optic-guwam.jpg";
// import interiorFoamImage from "./images/interior-foam.jpg";
// import roofInsulationRepairImage from "./images/roof-insulation-repair.jpg";
// import soundInsulationImage from "./images/sound-insulation.jpg";

const services = [
  {
    title: "ايبوكسي أرضيات بالرياض",
    image: epoxyImage,
    description:
      "تنفيذ احترافي لأعمال ايبوكسي الأرضيات في الرياض للمنازل، المستودعات، المصانع والجراجات بأعلى معايير الجودة والمتانة.",
    whatsapp: "أرغب في تنفيذ ايبوكسي أرضيات بالرياض",
  },
  {
    title: "دهانات داخلية في الرياض",
    image: interiorImage,
    description:
      "دهانات داخلية عصرية مع ديكورات فوم وجبس بورد، تشطيبات فاخرة تعكس الذوق الحديث للمنازل والفلل.",
    whatsapp: "أحتاج دهانات داخلية حديثة في الرياض",
  },
  {
    title: "دهانات خارجية بالرياض",
    image: exteriorImage,
    description:
      "دهانات خارجية مقاومة للحرارة والعوامل الجوية، ألوان ثابتة وتشطيب يدوم لسنوات في أجواء الرياض.",
    whatsapp: "أرغب في دهانات خارجية بالرياض",
  },
  // {
  //   title: "بديل الخشب في الرياض",
  //   image: woodImage,
  //   description:
  //     "تركيب بديل الخشب للجدران والأسقف بتصاميم فخمة تناسب الديكورات الحديثة والكلاسيك.",
  //   whatsapp: "أرغب في تركيب بديل الخشب بالرياض",
  // },
  {
    title: "ديكورات فوم وجبس بالرياض",
    image: decorImage,
    description:
      "تنفيذ ديكورات فوم وجبس بورد احترافية تضيف لمسة جمالية راقية للمساحات الداخلية.",
    whatsapp: "أحتاج ديكورات فوم وجبس في الرياض",
  },
  {
    title: "أسقف ألياف ضوئية بالرياض",
    image: ceilingsImage,
    description:
      "تصميم وتنفيذ أسقف ألياف ضوئية تمنح المكان فخامة وإضاءة هادئة بتقنيات حديثة.",
    whatsapp: "أرغب في تنفيذ أسقف ألياف ضوئية بالرياض",
  },
  // {
  //   title: "تركيب ورق جدران بالرياض",
  //   image: wallpaperImage,
  //   description:
  //     "يوفر لكم خدمات وأعمال الديكور العصري مع أحدث موديلات ورق الحائط للجدران 2024. أفضل فني متخصص لتنفيذ ديكورات الجدران العصرية في الرياض، بخبرة تفوق 15 سنة.",
  //   whatsapp: "أرغب في تركيب ورق جدران بالرياض",
  // },
  // {
  //   title: "دهانات خارجية الرياض – عسيب",
  //   image: exteriorAseebImage,
  //   description:
  //     "معلم دهانات وديكورات الرياض يقدم دهانات خارجية عالية الجودة، عسيب مقاوم للعوامل الجوية، بألوان جذابة ومتميزة.",
  //   whatsapp: "أرغب في دهانات خارجية عسيب بالرياض",
  // },
  // {
  //   title: "اسقف الياف ضوئية الرياض – نجوم روز",
  //   image: fiberOpticStarsImage,
  //   description:
  //     "أسقف ألياف ضوئية على شكل نجوم، ديكورات فاخرة، تضيف منظر جميل ورونق خاص لمكانك في الرياض.",
  //   whatsapp: "أرغب في تركيب أسقف ألياف ضوئية على شكل نجوم بالرياض",
  // },
  // {
  //   title: "اسقف الياف ضوئية الرياض – غيوام",
  //   image: fiberOpticGuwamImage,
  //   description:
  //     "معلم دهانات وديكورات الرياض يقدم تنفيذ أسقف ألياف ضوئية من نوع غيوام لتجربة فخمة وعصرية.",
  //   whatsapp: "أرغب في تركيب أسقف ألياف ضوئية غيوام بالرياض",
  // },
  // {
  //   title: "دهانات داخلية وفوم الرياض",
  //   image: interiorFoamImage,
  //   description:
  //     "دهانات داخلية مع ديكورات فوم، تنفيذ تشطيبات عالية الجودة، تضيف لمسة جمالية للمنازل والفلل.",
  //   whatsapp: "أرغب في خدمات دهانات داخلية وفوم بالرياض",
  // },
  // {
  //   title: "عوازل سطوح ودهانات داخلية ترميم",
  //   image: roofInsulationRepairImage,
  //   description:
  //     "دهانات وديكورات داخلية، ترميم وتشطيب الأسطح، تطبيق العزل المائي لحماية المنزل.",
  //   whatsapp: "أرغب في خدمات عوازل سطوح وترميم دهانات داخلية بالرياض",
  // },
  // {
  //   title: "عوازل صوت في الرياض",
  //   image: soundInsulationImage,
  //   description:
  //     "معلم دهانات وديكورات الرياض يقدم حلول عوازل صوتية عالية الجودة، ترميم وإزالة دهانات قديمة، إضافة لمسة احترافية.",
  //   whatsapp: "أرغب في تركيب عوازل صوت في الرياض",
  // },
];

const NUMBER = "966582114639";

export default function Services() {
  return (
    <section className="services-section1">
      <h1 className="main-title1">
        معلم دهانات وديكورات في الرياض – تشطيب باحتراف
      </h1>

      <div className="services-grid1">
        {services.map((item, i) => (
          <div className="service-card1" key={i}>
            <div className="image-box1">
              <img src={item.image} alt={item.title} />
            </div>

            <div className="content1">
              <h2>{item.title}</h2>
              <p>{item.description}</p>

              <a
                href={`https://wa.me/${NUMBER}?text=${encodeURIComponent(
                  item.whatsapp
                )}`}
                target="_blank"
                rel="noreferrer"
                className="whatsapp-btn1"
              >
                تواصل عبر واتساب
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
